namespace GeniuzPOS.RefundReasonReport {
    export interface ReportRefundReasonSumBillDtRow {
        Id?: string;
        ShopId?: string;
        ShopName?: string;
        PosId?: string;
        CashierId?: string;
        CashierName?: string;
        RefundId?: number;
        RefundReason?: string;
        SalesmanId?: string;
        SalesmanName?: string;
        MbId?: string;
        MbNameT?: string;
        DocNo?: string;
        DocDate?: string;
        DocTime?: string;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSales?: number;
        NetSalesExVat?: number;
        NetSalesNonVat?: number;
        VatOfNetSales?: number;
        BillCharge?: number;
        VatOfCharge?: number;
    }

    export namespace ReportRefundReasonSumBillDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ShopId';
        export const localTextPrefix = 'RefundReasonReport.ReportRefundReasonSumBillDt';
        export const lookupKey = 'RefundReasonReport.ReportRefundReasonSumBillDt';

        export function getLookup(): Q.Lookup<ReportRefundReasonSumBillDtRow> {
            return Q.getLookup<ReportRefundReasonSumBillDtRow>('RefundReasonReport.ReportRefundReasonSumBillDt');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            ShopId = "ShopId",
            ShopName = "ShopName",
            PosId = "PosId",
            CashierId = "CashierId",
            CashierName = "CashierName",
            RefundId = "RefundId",
            RefundReason = "RefundReason",
            SalesmanId = "SalesmanId",
            SalesmanName = "SalesmanName",
            MbId = "MbId",
            MbNameT = "MbNameT",
            DocNo = "DocNo",
            DocDate = "DocDate",
            DocTime = "DocTime",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSales = "NetSales",
            NetSalesExVat = "NetSalesExVat",
            NetSalesNonVat = "NetSalesNonVat",
            VatOfNetSales = "VatOfNetSales",
            BillCharge = "BillCharge",
            VatOfCharge = "VatOfCharge"
        }
    }
}
